import { Component, Vue, Prop } from 'vue-property-decorator';
import spinnerGradient from '../../../telstra-ui-resources/images/spinner-gradient.svg';

@Component
export default class Spinner extends Vue {
  @Prop() size!: string | 'xlarge' | 'large' | 'medium' | 'small';

  render(): JSX.Element {
    // This CSS classname logic is from the original library, but is incorrect. This has been fixed to correctly apply the size-specific className
    // Leaving this comment here so that we know to re-apply this fix if we port the logic again (e.g. a new version of the library)
    //
    // Original code:
    // className={'tl-spinner tl-ui '.concat(this.size)}>
    //

    return <img
        src={spinnerGradient}
        alt=''
        class={'tl-spinner tl-ui tl-spinner-'.concat(this.size)}>
        </img>;
  }
}
